import { useState, useEffect } from 'react';
import { AlgorithmSettingsProps } from 'src/components/auto-shapes/types';
import { AutoShapeAlgorithmType } from 'src/gql/graphql';

export function RoomDetection3DSettings({
  value,
  onChange,
  onValidityChange,
}: AlgorithmSettingsProps<AutoShapeAlgorithmType.RoomDetection_3D>) {
  // Example implementation
  const [localValue, setLocalValue] = useState(value);

  const validateInput = (input: any) => {
    return false;
  };

  useEffect(() => {
    // Validate and update parent
    const isValid = validateInput(localValue);
    onValidityChange(isValid);
    onChange(localValue);
  }, [localValue, onChange, onValidityChange]);

  return (
    // Your settings UI here
    <div>Room Detection 2D Settings</div>
  );
}
